(function () {
    function cookie_img() {
        const cookie_iframeImg = document.querySelector(
            ".cookieconsent-optout-marketing picture img"
        );
        if (cookie_iframeImg != null) {
            const cookie_iframeImgURL = cookie_iframeImg.getAttribute("src");
            const cookie_iframe = document.querySelector(
                ".Iframe_container .cookieconsent-optin-marketing iframe"
            );
            if (cookie_iframe != null) {
                cookie_iframe.style.backgroundImage = "url(" + cookie_iframeImgURL + ")";
            }
        }
    }
    
    window.addEventListener("load", cookie_img);
})();